import cn from 'classnames';
import React, { InputHTMLAttributes } from 'react';
import { useTranslation } from 'next-i18next';
export interface Props extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  inputClassName?: string;
  labelKey?: string;
  placeholderKey?: string;
  name: string;
  errorKey?: string;
  type?: string;
  shadow?: boolean;
  disableBorderRadius?: boolean;
  variant?: 'normal' | 'solid' | 'outline';
}
const classes = {
  root: 'py-2 px-4 md:px-5 w-full appearance-none transition duration-150 ease-in-out border text-input dark:text-neutral-200 text-xs lg:text-sm font-body placeholder-body min-h-12 focus:dark:border-neutral-400 transition duration-200 ease-in-out',
  normal: 'bg-gray-100 border-gray-300 focus:dark:border-neutral-400 focus:shadow focus:bg-white dark:bg-zinc-950 focus:border-primary',
  solid: 'bg-white dark:bg-zinc-950 border-gray-300 dark:border-neutral-600 focus:dark:border-neutral-400 focus:outline-none focus:border-heading dark:focus:border-neutral-500 h-11 md:h-12',
  outline: 'border-gray-300 focus:border-primary focus:dark:border-neutral-500',
  shadow: 'focus:shadow'
};
const Input = React.forwardRef<HTMLInputElement, Props>(({
  className = 'block',
  labelKey,
  name,
  errorKey,
  placeholderKey,
  variant = 'normal',
  shadow = false,
  type = 'text',
  disableBorderRadius = false,
  inputClassName,
  ...rest
}, ref) => {
  const rootClassName = cn(classes.root, {
    [classes.normal]: variant === 'normal',
    [classes.solid]: variant === 'solid',
    [classes.outline]: variant === 'outline'
  }, {
    [classes.shadow]: shadow
  }, inputClassName);
  const {
    t
  } = useTranslation();
  return <div className={className}>
        {labelKey && <label htmlFor={name} className="block text-neutral-600 dark:text-neutral-200 font-semibold text-sm leading-none mb-3 cursor-pointer">
            {t(labelKey)}
          </label>}
        <input id={name} name={name} type={type} ref={ref}
    // @ts-ignore
    placeholder={t(placeholderKey)} className={rootClassName + `${!disableBorderRadius && ' rounded-md'}`} autoComplete="off" spellCheck="false" aria-invalid={errorKey ? 'true' : 'false'} {...rest} />
        {errorKey && <p className="my-2 text-xs text-red-500">{t(errorKey)}</p>}
      </div>;
});
export default Input;